module.exports = __webpack_public_path__ + "img/sol_isol_pain2.19043f07.png";